import { ref } from 'vue';
import { usePostSaleSalesDetailActions } from './usePostSaleSalesDetailActions';
import { postSaleTableActionLocation } from './postSaleTableActionNavigation';

export function usePostSaleTableActions({
  accountId,
  notify,
  refresh,
  router,
  t,
}) {
  const action = ref('');
  const caseData = ref(null);
  const detailActions = usePostSaleSalesDetailActions({
    postSaleCase: caseData,
    notify,
    t,
  });

  const close = () => {
    action.value = '';
    caseData.value = null;
  };

  const open = context => {
    const location = postSaleTableActionLocation({
      accountId,
      action: context?.action,
      postSaleCase: context?.postSaleCase,
    });
    if (location) return router.push(location);

    if (!['assign', 'cancel'].includes(context?.action)) return null;

    caseData.value = context.postSaleCase;
    action.value = context.action;
    return null;
  };

  const assign = async responsibleUserId => {
    const result = await detailActions.assign(responsibleUserId);
    if (result) {
      close();
      await refresh();
    }
    return result;
  };

  const cancel = async payload => {
    const result = await detailActions.cancel(payload);
    if (result) {
      close();
      await refresh();
    }
    return result;
  };

  return {
    action,
    agents: detailActions.agents,
    assign,
    assigning: detailActions.assigning,
    cancel,
    cancelling: detailActions.cancelling,
    caseData,
    close,
    loadingAgents: detailActions.loadingAgents,
    open,
  };
}
